/**
 * Day-one checklist — shown in Soren Today for companies with no projects yet.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchDayOneChecklist, type DayOneChecklistItem } from '../../api/help'

interface Props {
  onOpenHref: (href: string) => void
}

export default function SorenDayOneChecklist({ onOpenHref }: Props) {
  const { data, isLoading } = useQuery({
    queryKey: ['help-day-one'],
    queryFn: fetchDayOneChecklist,
    staleTime: 30_000,
  })

  const items = data?.items ?? []
  if (isLoading || items.length === 0) return null

  return (
    <section
      className="soren-day-one"
      data-testid="soren-day-one-checklist"
      aria-label="Get started checklist"
    >
      <h3 className="soren-day-one__title">Get started</h3>
      <p className="soren-day-one__sub">Finish these before your first pay app.</p>
      <ol className="soren-day-one__list">
        {items.map((item: DayOneChecklistItem) => (
          <li key={item.id} className="soren-day-one__item">
            <button
              type="button"
              className="soren-day-one__link"
              data-testid={`day-one-${item.id}`}
              onClick={() => onOpenHref(item.deep_link)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ol>
    </section>
  )
}
